import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import capitalize from '../../../../utils/capitalize';
import deconstructLocation from '../../../../utils/deconstructLocation';
import deparameterize from '../../../../utils/deparameterize';
import useRecentSearches from '../../common/hooks/useRecentSearches';
import useSearchAreaSuggest from '../../common/hooks/useSearchAreaSuggest';

const getValuesFromParams = params => {
  const {
    categoryName,
    slug,
    state: stateParam,
    region,
    suburb: suburbParam,
  } = params;
  const { state: stateSlug, suburb: suburbSlug } = slug
    ? deconstructLocation(slug)
    : {};
  const state = stateParam || stateSlug ? stateParam || stateSlug : undefined;
  const suburb =
    suburbParam || suburbSlug ? suburbParam || suburbSlug : undefined;

  const keyword = categoryName
    ? capitalize(deparameterize(categoryName))
    : undefined;
  const searchAreaName = (() => {
    if (!state) return undefined;
    if (!region && !suburb) return '';
    return capitalize(deparameterize(suburb || region));
  })();

  return {
    keyword,
    searchAreaName,
  };
};

const useInitialSearch = () => {
  const location = useLocation();
  const baseParams = useParams();
  const queryParameters = new URLSearchParams(location.search);
  const categoryName = queryParameters.get('what');
  const slug = queryParameters.get('where');
  const { keyword, searchAreaName } = getValuesFromParams(
    categoryName || slug ? { categoryName, slug } : baseParams
  );
  const { pathname } = useLocation();
  const {
    fetchSearchAreaSuggestions,
    topSearchAreaSuggestion,
  } = useSearchAreaSuggest();
  const { addToRecentSearches } = useRecentSearches();

  useEffect(() => {
    if (searchAreaName) {
      fetchSearchAreaSuggestions({
        query: searchAreaName,
        debounceFetch: false,
      });
    } else if (keyword) {
      addToRecentSearches({ keyword, path: pathname });
    }
  }, [keyword, searchAreaName, pathname]);

  useEffect(() => {
    if (
      topSearchAreaSuggestion &&
      topSearchAreaSuggestion.name === searchAreaName
    ) {
      addToRecentSearches({
        keyword,
        path: pathname,
        selectedSearchArea: topSearchAreaSuggestion,
      });
    }
  }, [topSearchAreaSuggestion, keyword]);

  return { keyword, searchAreaName };
};

export default useInitialSearch;
